/**
 * Format price with currency symbol
 */
export function formatPrice(price: number, currency: string = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(price);
}

/**
 * Format date
 */
export function formatDate(date: string | Date, format: 'short' | 'long' = 'short'): string {
  const d = typeof date === 'string' ? new Date(date) : date;

  if (format === 'long') {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(d);
  }

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d);
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

/**
 * Generate initials from name
 */
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName?.charAt(0)}${lastName?.charAt(0)}`.toUpperCase();
}


/**
* Format phone number to US international format
* Always prepends +1 for US numbers
*/
export const formatPhoneNumber = (value: string) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  if (!phoneNumber) return '';
  
  // Remove any existing +1 or 1 prefix
  const cleaned = phoneNumber.replace(/^(\+?1)/, '');
  const len = cleaned.length;
  
  if (len === 0) return '+1 ';
  if (len < 4) return `+1 ${cleaned}`;
  if (len < 7) return `+1 ${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  return `+1 ${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};
